<template>
  <a-modal
    class="client-modal-wrapper hospital-modal"
    :destroy-on-close="true"
    width="722px"
    :mask-closable="false"
    :visible="businessVisible"
    :footer="null"
    :title="businessModalTitle"
    @cancel="$emit('onCancelBusinessModal')"
  >
    <basic-form ref="basicForm" :form-data="formData">
      <template #name>
        <a-input
          v-decorator="[
            'name',
            { rules: [{ required: true, message: '请选择客户' }] },
          ]"
          style="width: 463px"
          placeholder="请输入客户名称"
          @change="handleChange"
        />
        <!-- <a-button
          type="primary"
          style="margin-left: 10px"
          @click="seach_hospital"
        >
          搜索
        </a-button> 
        <ul v-show="seach" class="select-wrapper">
          <a-spin v-if="infoLoading" style="margin: 6px" />
          <li
            v-for="(item, index) in seach_hospital_list"
            :key="index"
            class="select-item"
            @click="select_hospital(index)"
          >
            {{ item.hosName }}
          </li>
        </ul>
        -->
      </template>

      <template #provinceCity>
        <client-province-city
          v-decorator="[
            'provinceCity',
            { rules: [{ required: true, message: '请选择省市' }] },
          ]"
        />
      </template>

      <template #address>
        <coordinatePickQqMap
          ref="coordinatePickRef"
          :maps="maps"
          :addrs="addrs"
          v-decorator="[
            'address',
            { rules: [{ required: true, message: '请选择客户地址' }] },
          ]"
        />
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>
<script>
import ClientProvinceCity from "../components/ProvinceCity";
import coordinatePickQqMap from "@/components/coordinatePickQqMap";
export default {
  components: {
    ClientProvinceCity,
    coordinatePickQqMap,
  },
  props: [
    "businessVisible",
    "formData",
    "businessModalTitle",
    "type",
    "maps",
    "addrs",
  ],
  data() {
    return {
      seach: false,
      seach_hospital_list: [],
      keyword: "",
      infoLoading: true,
    };
  },
  mounted() {},
  methods: {
    handleChange(e) {
      this.keyword = e.target.value;
    },
    // 选中的医院资料
    select_hospital(i) {
      let selhospital = this.seach_hospital_list[i];
      console.log(selhospital);
      this.seach = false;
      this.$refs.basicForm.form.setFieldsValue({
        name: selhospital.hosName,
      });
    },
    // 搜索医院
    async seach_hospital() {
      if (!this.keyword) {
        this.$message.warning("请输入关键词！");
        return;
      }
      this.infoLoading = true;
      this.seach_hospital_list = [];
      this.seach = true;
      let result = await this.$http.post("/system/get_country_hospital_list", {
        keyword: this.keyword,
      });
      if (result.data.status === 1) {
        this.infoLoading = false;
        if (result.data.data.length > 0) {
          this.seach_hospital_list = result.data.data;
        } else {
          this.seach_hospital_list = [
            {
              hosName: "暂无数据",
            },
          ];
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.select-wrapper {
  width: 392px;
  max-height: 250px;
  min-height: 30px;
  z-index: 100;
  position: absolute;
  padding: 0;
  background: #fff;
  border-radius: 4px;
  overflow: auto;
  margin-top: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;

  .select-item {
    line-height: 15px;
    list-style: none;
    padding: 7px 10px;
    margin: 0;
    cursor: pointer;

    &:hover {
      background: #e6f7ff;
    }
  }
}
</style>